import * as React from "react";

export const CollapsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="#CDD3DC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.042"
      clipPath="url(#clip0_21076_11428)"
    >
      <path d="M5 11.667h3.333V15M12.5 7.5l5-5M15 8.333h-3.333V5M7.5 12.5l-5 5M3.333 9.167V5c0-.92.746-1.667 1.667-1.667h4.166M16.667 10.833V15c0 .92-.746 1.667-1.667 1.667h-5"></path>
    </g>
    <defs>
      <clipPath id="clip0_21076_11428">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
